export default __webpack_public_path__ + "static/media/voh-radio.2e55ba29.png";